// @core/api/endpoints/project/create_milestone.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateMilestoneRequest,
  MilestoneResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create milestone
 * Creates a project milestone with a target date. Milestones mark significant project goals and can have items associated with them.
 */
export async function CreateMilestone(
  project_id: string,
  data: CreateMilestoneRequest,
  options?: RequestOptions
): Promise<MilestoneResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/milestones`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<MilestoneResponse>(requestPath, data, requestOptions);
}
